module.exports = __webpack_public_path__ + "assets/img/logo.33085480.png";